
import TableCellPropertyCommand from './tablecellpropertycommand';

export default class TableCellVerticalAlignmentCommand extends TableCellPropertyCommand {
    /**
     * Creates a new `TableCellVerticalAlignmentCommand` instance.
     *
     * @param editor An editor in which this command will be used.
     * @param defaultValue The default value for the "alignment" attribute.
     */
    constructor(editor, defaultValue) {
        super(editor, 'tableCellVerticalAlignment', defaultValue);
    }
}
